"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifestyleId = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const CollapseIntakeWeighting_1 = __importDefault(require("./CollapseIntakeWeighting"));
const CollapseIntakeBuildingPlan_1 = __importDefault(require("./CollapseIntakeBuildingPlan"));
const OfflineInfo_1 = __importDefault(require("../offline-mode/OfflineInfo"));
const loading_1 = require("../../molecules/loading");
const hooks_1 = require("../../shared/hooks");
const Codes_1 = __importDefault(require("./Codes"));
const Nutrition_1 = __importDefault(require("./Nutrition"));
const LifestyleId = (props) => {
    const { isOffline } = (0, hooks_1.useNetwork)();
    if (!props.intake) {
        if (isOffline) {
            return (0, jsx_runtime_1.jsx)(OfflineInfo_1.default, { translations: props.offlineTranslation }, void 0);
        }
        return (0, jsx_runtime_1.jsx)(loading_1.Loading, {}, void 0);
    }
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(Codes_1.default, { code: props.code }, void 0), (0, jsx_runtime_1.jsx)(Nutrition_1.default, { foodPreferences: props.foodPreferences }, void 0), (0, jsx_runtime_1.jsx)(CollapseIntakeBuildingPlan_1.default, { intake: props.mapIntakeBodyCharacteristics(props.intake), translations: props.intakeTranslations, tableName: props.intakeTranslations.questions.generalQuestions }, void 0), (0, jsx_runtime_1.jsx)(CollapseIntakeWeighting_1.default, { intake: props.mapIntakeBodyCharacteristics(props.intake), translations: props.intakeTranslations, sortHormoneAndDist: props.orderedMapFromValues, tableName: props.intakeTranslations.tableTranslations.weight }, void 0)] }, void 0));
};
exports.LifestyleId = LifestyleId;
const Wrapper = styled_components_1.default.div `
  & > div:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }
`;
//# sourceMappingURL=index.js.map